import camelcaseKeys from 'camelcase-keys';
import snakeCaseKeys from 'snakecase-keys';
import axios from 'axios';

export const ADD_CHECKLIST_ITEM = 'add_checklist_item';
export const UPDATE_CHECKLIST_ITEM = 'update_checklist_item';
export const UPDATE_CHECKLIST_ITEMS = 'update_checklist_items';
export const DELETE_CHECKLIST_ITEM = 'delete_checklist_item';
export const TOGGLE_CHECKLIST_ITEM_MODAL = 'toggle_checklist_item_modal';

export function updateChecklistItem(data) {
  return (dispatch, getState) => {
    const path = `${getState().checklistItemModal.addChecklistItemPath}/${data.projects_checklist_item.id}`;
    return axios.put(path, snakeCaseKeys(data)).then((response) => {
      dispatch({
        type: UPDATE_CHECKLIST_ITEM,
        payload: { data: camelcaseKeys(response.data, { deep: true }) }
      });
    });
  };
}

export function addChecklistItem(data) {
  return (dispatch, getState) => {
    return axios.post(getState().checklistItemModal.addChecklistItemPath, snakeCaseKeys(data)).then((response) => {
      dispatch({
        type: ADD_CHECKLIST_ITEM,
        payload: { data: camelcaseKeys(response.data, { deep: true }) }
      });
    });
  };
}

export function editChecklistItem(item) {
  return ({ type: TOGGLE_CHECKLIST_ITEM_MODAL, payload: { show: true, item } });
}

export function reorderChecklistItemsRemotely(items) {
  const data = {
    projects_checklist_items: items.map((item, index) => {
      return { id: item.id, sortOrder: index };
    })
  };

  return (dispatch, getState) => {
    const path = getState().checklistItemModal.addChecklistItemPath;
    return axios.patch(path, snakeCaseKeys(data)).then((response) => {
      dispatch({
        type: UPDATE_CHECKLIST_ITEMS,
        payload: { data: camelcaseKeys(response.data.checklist_items, { deep: true }) }
      });
    });
  };
}

export function reorderChecklistItemsLocally(items) {
  return { type: UPDATE_CHECKLIST_ITEMS, payload: { data: items } };
}

export function deleteChecklistItem(id) {
  return (dispatch, getState) => {
    return axios.delete(`${getState().checklistItemModal.addChecklistItemPath}/${id}`).then(() => {
      dispatch({
        type: DELETE_CHECKLIST_ITEM,
        payload: id
      });
    });
  };
}

export function showChecklistItemModal(projectStatus, listingType) {
  return ({ type: TOGGLE_CHECKLIST_ITEM_MODAL, payload: { show: true, item: null, projectStatus, listingType } });
}

export function hideChecklistItemModal() {
  return ({ type: TOGGLE_CHECKLIST_ITEM_MODAL, payload: { show: false, item: null } });
}
